import awsconfig from '../aws-exports';

// Extract environment from API endpoint
export function getEnvFromConfig () {
    // From API endpoint URL which ends with /dev
    if (awsconfig.aws_cloud_logic_custom &&
        awsconfig.aws_cloud_logic_custom[0] &&
        awsconfig.aws_cloud_logic_custom[0].endpoint) {
        const endpoint = awsconfig.aws_cloud_logic_custom[0].endpoint;
        const match = endpoint.match(/\/([^/]+)$/);
        if (match && match[1]) {
            return match[1]; // Returns 'dev', 'prod', etc.
        }
    }

    // Fallback: check S3 bucket name which contains -dev
    if (awsconfig.aws_user_files_s3_bucket) {
        if (awsconfig.aws_user_files_s3_bucket.includes('-dev')) {
            return 'dev';
        } else if (awsconfig.aws_user_files_s3_bucket.includes('-prod')) {
            return 'prod';
        }
    }

    return 'unknown';
};

